import { MediaActionTypes, RESET_MAGAZINE_URL } from '../actions/mediaActions';
import { sortBy } from 'lodash';

const defaultState = {
  error: null,
  loading: false,
  generating: false,
  data: {},
  url: ''
};

function onFetchMediaSuccess(state, media) {
  let countries = [];
  let languages = {};
  let categoriesData = {};
  let keywordsData = {};
  let UnitedState = null;
  (media || []).forEach(item => {
    const countryCode = item.countryCode;
    countries.push({ label: item.countryName, value: countryCode });
    languages[countryCode] = [];
    categoriesData[countryCode] = {};
    keywordsData[countryCode] = {};
    //set default country United States
    if (countryCode === 'US') {
      UnitedState = { label: item.countryName, value: countryCode };
    }
    (item.languages || []).forEach(
      ({ languageName, languageCode, categories, keywords }) => {
        languages[countryCode].push({
          label: languageName,
          value: languageCode
        });
        categoriesData[countryCode][languageCode] = categories;
        keywordsData[countryCode][languageCode] = keywords;
      }
    );
  });

  return {
    ...state,
    loading: false,
    data: {
      countries: sortBy(countries, 'label'),
      languages,
      categoriesData,
      keywordsData,
      UnitedState
    }
  };
}

export default function(state = defaultState, { type, countries, url, error }) {
  switch (type) {
    case MediaActionTypes.MEDIA_DATA_REQUESTED:
      return {
        ...state,
        data: {},
        loading: true
      };
    case MediaActionTypes.MEDIA_DATA_SUCCEEDED:
      return onFetchMediaSuccess(state, countries);
    case MediaActionTypes.MEDIA_DATA_FAILED:
      return {
        ...state,
        error,
        data: {},
        loading: false
      };
    case MediaActionTypes.TAGS_DATA_REQUESTED:
      return {
        ...state,
        data: {},
        loading: true
      };
    case MediaActionTypes.TAGS_DATA_SUCCEEDED:
      return onFetchMediaSuccess(state, countries);
    case MediaActionTypes.TAGS_DATA_FAILED:
      return {
        ...state,
        error,
        data: {},
        loading: false
      };
    case MediaActionTypes.GENERATE_URL_REQUESTED:
      return {
        ...state,
        generating: true
      };
    case MediaActionTypes.GENERATE_URL_SUCCEEDED:
      return {
        ...state,
        url,
        generating: false
      };
    case MediaActionTypes.GENERATE_URL_FAILED:
      return {
        ...state,
        error,
        generating: false
      };
    case RESET_MAGAZINE_URL:
      return {
        ...state,
        url: null
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/mediaReducer.js